import { FC, useMemo } from 'react';
import { SampleScope } from '../../../components/FrostedGate/SampleScope';
import { useSeedSampleCompanies } from '../../../components/FrostedGate/useSeedSampleCompanies';
import { Loader } from '../../../components/Loader/Loader';
import { PREVIEW_KPI_COMPANY_SETTINGS, PREVIEW_KPI_CONFIGURATIONS } from '../kpi-module.fixtures';
import { kpiBaseSeeds } from '../kpi-sample-seeds';
import { useSampleKpiCompanies } from '../useSampleKpiCompanies';
import { KpiCompanySettingsGrid } from './KpiCompanySettings';
import {
  KpiCollectionCompanySettingsQueryKey,
  KpiCollectionSettingsQueryKey,
} from './state/kpi-collection-state';

const QUERY_DATA = [
  [KpiCollectionSettingsQueryKey, PREVIEW_KPI_CONFIGURATIONS],
  [KpiCollectionCompanySettingsQueryKey, PREVIEW_KPI_COMPANY_SETTINGS],
] as const;

/** The live company settings grid over the sample portfolio, while the module is frosted. */
export const KpiCompanySettingsPreview: FC = () => {
  const companies = useSampleKpiCompanies();
  // The grid resolves companies through the app store directly, so they have to be there too.
  const seeded = useSeedSampleCompanies(companies);
  const seeds = useMemo(() => kpiBaseSeeds(companies), [companies]);

  if (!seeded) {
    return <Loader />;
  }
  return (
    <SampleScope seeds={seeds} queryData={QUERY_DATA}>
      <KpiCompanySettingsGrid />
    </SampleScope>
  );
};
